import ProfileTypes from './profile.types';
import { formatDate } from '../../utils/commonFunctions';

export const updateProfileDetails = (obj) => ({
	type: ProfileTypes.UPDATE_PROFILE_DETAILS.PENDING,
	payload: obj,
});

export const onPhoneChange = (text) => ({
	type: ProfileTypes.CHANGE_PHONE,
	payload: text,
});

export const onEmailChange = (text) => ({
	type: ProfileTypes.CHANGE_EMAIL,
	payload: text,
});

export const onFullNameChange = (text) => ({
	type: ProfileTypes.CHANGE_FULL_NAME,
	payload: text,
});

export const getProfileDetails = () => ({
	type: ProfileTypes.GET_PROFILE_DETAILS.PENDING,
});

export const addProfileDetails = (obj) => ({
	type: ProfileTypes.ADD_PROFILE_DETAILS.PENDING,
	payload: obj,
});

export const updateCoachStream = (obj) => ({
	type: ProfileTypes.UPDATE_COACH_STREAM.PENDING,
	payload: obj,
});


export const addOnboardDetails = (obj) => ({
	type: ProfileTypes.ADD_ONBOARD_DETAILS.PENDING,
	payload: obj,
});

export const showHideUserType = (val) => ({
	type: ProfileTypes.SHOW_HIDE_USER_TYPE,
	payload: val,
});

export const resetStateVal = () => ({
	type: ProfileTypes.RESET_STATE_VAL,
});

export const handleInputChange = (event) => ({
	type: ProfileTypes.HANDLE_INPUT_CHANGE,
	payload: event,
});

export const resetPin = () => ({
	type: ProfileTypes.RESET_PIN,
});

export const handleDateChange = (date) => ({
	type: ProfileTypes.HANDLE_DATE_CHANGE,
	payload: formatDate(date, 'YYYY-MM-DD'),
});

export const handleGraduateYearChange = (date) => ({
	type: ProfileTypes.HANDLE_GRADUATE_DATE_CHANGE,
	payload: formatDate(date, 'YYYY-MM-DD'),
});

export const toggleEdit = () => ({
	type: ProfileTypes.TOGGLE_PROFILE_EDIT,
});

export const sendOTP = (phone) => ({
	type: ProfileTypes.SEND_MOBILE_OTP.PENDING,
	payload: phone,
});

export const verifyOTP = (otp) => ({
	type: ProfileTypes.VERIFY_MOBILE_OTP.PENDING,
	payload: otp,
});

export const setSubscription = (obj) => ({
	type: ProfileTypes.SUBCRIBE_FOR_UPDATES.PENDING,
	payload: obj,
});

export const setShowSubscribe = (val) => ({
	type: ProfileTypes.SHOW_SUBSCRIBE,
	payload: val,
});

export const setGetUserInfo = (val) => ({
	type: ProfileTypes.SHOW_USER_MODAL,
	payload: val,
});

export const setShowVerifyMob = (val) => ({
	type: ProfileTypes.SHOW_VERIFY_MOB,
	payload: val,
});
